import { useMemo } from 'react';
import { useMaterialReactTable, MaterialReactTable } from 'material-react-table';
import { connect } from 'react-redux';

const NumericalSummary = ({ stats }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Field Name',
        filterVariant: 'select',
      },
      {
        accessorKey: 'null_perc',
        header: 'Null Value Percentage (in %)',
        filterVariant: 'range',
      },
      {
        accessorKey: 'outlier_perc',
        header: 'Possible Outlier Percentage (in %)',
        filterVariant: 'range',
      },
      {
        accessorKey: 'population_15_perc',
        header: '15-Min Population Percentage (in %)',
        filterVariant: 'range',
      },
      {
        accessorKey: 'min',
        header: 'Minimum',
        filterVariant: 'range',
      },
      {
        accessorKey: 'median',
        header: 'Median',
        filterVariant: 'range',
      },
      {
        accessorKey: 'max',
        header: 'Maximum',
        filterVariant: 'range',
      },
      {
        accessorKey: 'std',
        header: 'Standard Deviation',
        filterVariant: 'range',
      },
    ],
    []
  );
  const mrt = useMaterialReactTable({
    enableFacetedValues: true,
    muiTableHeadCellProps: {
      sx: {
        textAlign: 'center',
        verticalAlign: 'middle',
        '& .Mui-TableHeadCell-Content': {
          justifyContent: 'center',
        },
      },
    },
    muiTableBodyCellProps: { sx: { textAlign: 'center', verticalAlign: 'middle' } },
    // TODO: Pull these into a common from explore/util.jsx
    columns,
    data: stats.summary,
    initialState: {},
  });
  return <MaterialReactTable table={mrt} />;
};

export default connect()(NumericalSummary);
